import { AppConfig, AppService } from '@aperza/util';
import React from 'react';
import { useAperzaUserContext } from './header/AperzaUserContext';
import { addUtmParam } from './addUtmParam';
import { useResponsiveContext } from './util/ResponsiveContext';
export default function ServiceLogo() {
    const { serviceType } = useAperzaUserContext();
    const { isMobile } = useResponsiveContext();
    let imageFile = 'logo.svg';
    let url = AppService.wwwServerHost();
    let alt = 'ものづくり産業向けポータルサイト Apérza（アペルザ）';
    let width = 128;
    const height = 43; // (fixed)
    let mWidth = 90; // Mobile width
    const mHeight = 30; // Mobile height (fixed)
    switch (serviceType) {
        case AppConfig.APERZA_TV:
            imageFile = 'logo_tv.svg';
            url = AppService.tvServerHost();
            alt = 'ものづくり産業向けカタログサイト Apérza TV（アペルザTV）';
            width = 174;
            mWidth = 122;
            break;
        case AppConfig.APERZA_NEWS:
            imageFile = 'logo_news.svg';
            url = AppService.newsServerHost();
            alt = 'ものづくり産業向けカタログサイト Apérza News（アペルザニュース）';
            width = 215;
            mWidth = 150;
            break;
        case AppConfig.APERZA_CATALOG:
            imageFile = 'logo_catalog.svg';
            url = `${AppService.wwwServerHost()}/catalog/`;
            alt = 'ものづくり産業向けカタログサイト Apérza Catalog（アペルザカタログ）';
            width = 251;
            mWidth = 175;
            break;
        case AppConfig.APERZA_EC:
            imageFile = 'logo_ec.svg';
            url = AppService.ecServerHost();
            alt = 'ものづくり産業向けカタログサイト Apérza EC（アペルザEC）';
            width = 174;
            mWidth = 121;
            break;
        case AppConfig.APERZA_DX:
            imageFile = 'logo_dx.svg';
            url = AppService.cloudServerHost();
            width = 176;
            mWidth = 123;
            break;
        default:
            break;
    }
    return (React.createElement("a", { href: addUtmParam(url, 'header', serviceType) },
        React.createElement("img", { alt: alt, src: `${AppService.staticServerHost()}/common/images/aperza2022/red/${imageFile}`, width: isMobile ? mWidth : width, height: isMobile ? mHeight : height })));
}
